// src/app/services/interceptor.service.ts
import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IError } from '../models/error.model';
import { ErrorService } from '../services/error.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private errorService: ErrorService,
    private injector: Injector
  ) { }

  /**
   * Handles error
   * @param errorRes 
   * @returns  
   */
  private handleError(errorRes: HttpErrorResponse) {

    let error = {} as IError;
    error = this.errorService.whichError(errorRes);

    return throwError(error);
  }

  /**
   * Intercepts error
   * @param req 
   * @param next 
   * @returns intercept 
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(
        catchError(err => this.handleError(err))
      );
  };
}